export default {
  getCompany: (state) => state.getCompany,
  company: (state) => state.company,
  cachedCompany: (state) => state.cachedCompany,
  companies: (state) => state.companies,
  companyById: (state) => state.companyById,
  cachedCompanyById: (state) => state.cachedCompanyById,
};
